import Vue from "vue";
import Vuex from "vuex";

import CommonModules from "../modules/Common/_store/index";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: CommonModules,
});
